import React, { useEffect, useState } from 'react';
import  '../ShareQuotations/ShareQuotation.css';
import axios from 'axios';
import { basePath } from '../../index';
import MaskedInput from 'react-text-mask';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import * as CopyToClipboard from 'react-copy-to-clipboard';
import ShowSideError from '../UtilityComponents/ShowSideError';
import Celebrating from './CelebratingParticles';



const maskEmail = (email = '') => {
    const [local, domain] = email.split('@');
    if (!domain) return email;               // no "@" yet, nothing to mask
    const visible = local.slice(0, 2);
    return `${visible}${'*'.repeat(Math.max(local.length - 2, 3))}@${domain}`;
};

const maskMobile = (num = '') => {
    const value = (num ?? '').toString();
    return value.length === 10
        ? `${value.slice(0, 2)}******${value.slice(-2)}`
        : value;                              // never mask a half-typed number
};

const ShareQuotations = ({ showModal, closeModal, EnquiryNo, LotNo, MobileNo, HiddenQuotes, ShareFor, Email }) => {
    //const [mobileNumber, setMobileNumber] = useState(MobileNo || "");
    // const [whatsappNumber, setWhatsappNumber] = useState('');
    //const [email, setEmail] = useState('');
    const [copySuccess, setCopySuccess] = useState('Copy');
    const [copyURL, setCopyURL] = useState(null);
    const [data, setData] = useState(null);
    const [shareId, setShareId] = useState('');
    const [error, setError] = useState({});
    const [copyText, setCopyText] = useState(false);
    const [isSuccessPopup, setIsSuccessPopup] = useState(false);

    //const [IsBtnDisabled, setIsBtnDisabled] = useState(true);
    //const [isActive, setIsActive] = useState(false);
    const [focusedField, setFocusedField] = useState(null);
    const [userDetail, setUserDetail] = useState({
        mobileNumber: MobileNo,
        whatsappNumber: MobileNo,
        email : Email
    })

    useEffect(() => {
        setUserDetail((prev) => ({
            ...prev,
            email: Email ?? ""
        }));
    }, [Email]);

    const handleCopy = () => {
        setCopyText(true);
        setTimeout(() => setCopyText(false), 2000);
    };


    

   /* useEffect(() => {
        setIsBtnDisabled(!MobileNo);
    }, [MobileNo]);
*/
    const handleChange = (e) => {
        const { name, value } = e.target;
        setUserDetail((prev) => ({
             ...prev, [name]: value
        }));
    };

   /* const validateEmail = (email) => {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }*/
    const validateEmail = (email) => {
        return /^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/.test(
            String(email).toLowerCase()
        );
    };

    const validateInput = (param) => {
        let error = {};
        let goto = true;
        if (param === 'mob' || param === 'wt') {
            if (!userDetail.mobileNumber) {
                goto = false;
                error[param === 'mob' ? 'mobileNumber' : 'whatsappNumber'] = `Please enter valid ${param === 'mob' ? 'mobile' : 'whatsapp'} number`;
            } else if ((param === 'mob' ? userDetail.mobileNumber : userDetail.whatsappNumber)?.length < 10) {
                goto = false;
                error[param === 'mob' ? 'mobileNumber' : 'whatsappNumber'] = `Entered ${param === 'mob' ? 'mobile' : 'whatsapp'} number should be of 10 digits`
            }
            else if ((param === 'mob' ? userDetail.mobileNumber : userDetail.whatsappNumber) === "9999999999" || (param === 'mob' ? userDetail.mobileNumber : userDetail.whatsappNumber) === "8888888888" || (param === 'mob' ? userDetail.mobileNumber : userDetail.whatsappNumber) === "7777777777" || (param === 'mob' ? userDetail.mobileNumber : userDetail.whatsappNumber) === "6666666666") {
                goto = false;
                error[param === 'mob' ? 'mobileNumber' : 'whatsappNumber'] = `Please enter valid ${param === 'mob' ? 'mobile' : 'whatsapp'} number`
            }
        } else if (param === 'email') {

            if (!userDetail.email) {
                goto = false;
                error['email'] = "Please enter email";
            } else if (!validateEmail(userDetail.email)) {
                goto = false;
                error['email'] = 'Please enter valid email'
            }
        }

        setError(error);
        return goto;
    }

    /*useEffect(() => {
        if (MobileNo !== userDetail.mobileNumber || MobileNo !== userDetail.whatsappNumber) {
            setIsBtnShow(false);
        } else {
            setIsBtnShow(true);
        }
    }, []);*/

    const postData = async (param) => {
        if (validateInput(param)) {
            const requestBody = {
                EnquiryNo,
                LotNo,
                ShareFor: ShareFor === "PROPOSAL" ? "PROPOSAL" : "QUOTATION",
                ShareMode: param === "mob" ? 0 : param === "email" ? 1 : param === "copy" ? 4 : 2,
                ShareTo: param === "mob" ? userDetail.mobileNumber : param === "email" ? userDetail.email : param === "copy" ? "copy@gmail.com" : "",
                UserID: 0,
                TransKey: "",
                HideInsurerIDs: HiddenQuotes,
                OtherData: ""
            };

            try {
                const response = await axios.post(`central/centralcall/callreqwithheader`, { URL: "ShareQuote", Req: requestBody })
                setData(response.data);
                if (param !== "copy") {
                    setIsSuccessPopup(true);
                    }
                setShareId(response.data.Data.Token.split('shareid')[1])
                if (param !== "copy")
                    console.log(response.data.Data.Message);
                else setCopyURL(response.data.Data.Token);
            } catch (error) {
                setError(error.message);
            }
            

        }
    };
    useEffect(() => {
        postData("copy");
    }, []);

    const redirectToWhatsapp = (param) => {
        if (validateInput(param)) {
            const link = `https://wa.me/${userDetail.whatsappNumber}?text=${window.location.origin + (ShareFor === "PROPOSAL" ? "/investment/investmentProposal":"/investment/investmentQuotes") + "?shareid" + shareId}`;
            window.open(link, '_blank');
        }
    }




    return (
        <div className="modalBackdrop_Share">
            {isSuccessPopup ? (
                <div className="modal_ShareQuotation">
                    <div className="modalHeader model_padding">
                        <h3 className="share_heading">Share {ShareFor === "PROPOSAL" ? "Proposal" : "Quotations"}</h3>
                        {/*<button className="closeButton" onClick={closeModal}>&times;</button>*/}
                        <button className="closeButton" onClick={closeModal}>
                            <img src={require("../../Investment/Cross.svg").default} alt="" />
                        </button>
                    </div>
                    <div className="modalBody">
                        <div className="Code_shared_success">
                            <h4>Your {ShareFor === "PROPOSAL" ? 'proposal' : "quote"} has been shared <br /><span class="success">successfully</span>!</h4>
                            <p>The details have been sent to the provided contact details.</p>
                        </div>
                    </div>
                    <Celebrating />
                </div>
            ) : (
                    <div className="modal_ShareQuotation">
                        <div className="modalHeader model_padding">
                            <h3 className="share_heading">Share {ShareFor === "PROPOSAL" ? "Proposal" : "Quotations"}</h3>
                            {/*<button className="closeButton" onClick={closeModal}>&times;</button>*/}
                            <button className="closeButton" onClick={closeModal}>
                                <img src={require("../../Investment/Cross.svg").default} alt="" />
                            </button>
                        </div>
                        {/*<hr />*/}
                        <div className="modalBody">
                            <nav className="tabItem">
                                <div className="model_padding model_padding3">
                                    <div class="nav" id="nav-tab" role="tablist">
                                        <button class="nav-link nav-linkINV active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">
                                            <span><i class="far fa-envelope"></i></span> Email
                                        </button>
                                        <button class="nav-link nav-linkINV" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">
                                            <span><i class="far fa-comment"></i></span> SMS
                                        </button>
                                        <button class="nav-link nav-linkINV" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">
                                            <span><i class="fab fa-whatsapp"></i></span> Whatsapp
                                        </button>
                                    </div>
                                </div>
                            </nav>
                            <div className="model_padding">
                                <div class="tab-content" id="nav-tabContent">
                                    <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                                        <div className="inputGroup">
                                            <div className="share_inp">
                                                {/*<input
                                                    type="text"
                                                    name="email"
                                                    placeholder=""
                                                    value={userDetail.email}
                                                    onChange={handleChange}
                                                    required
                                                />*/}

                                                <input
                                                    type="text"
                                                    name="email"
                                                    placeholder=""
                                                    value={
                                                        focusedField === 'email'
                                                            ? userDetail.email ?? ''
                                                            : maskEmail(userDetail.email ?? '')
                                                    }
                                                    onChange={handleChange}
                                                    onFocus={() => setFocusedField('email')}
                                                    onBlur={() => setFocusedField(null)}
                                                    required
                                                />

                                                <label className="label">Email Address</label>
                                            </div>
                                            <button className="shareButton" onClick={() => postData("email")} disabled={!userDetail.email}>Share</button>
                                        </div>
                                        <span className="shareQuoteErrorText">{error["email"]}</span>
                                    </div>
                                    <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                                        <div className="inputGroup">
                                            <div className="share_inp">
                                                {/*<span className="countryCodeStyle">
                                                    {isActive || userDetail.mobileNumber ? '+91' : ''}
                                                </span>
                                                <MaskedInput
                                                    className="inputText inputForMobile"
                                                    mask={[
                                                        /[6-9]/,
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                    ]}
                                                    guide={false}
                                                    showMask={false}
                                                    placeholder=""
                                                    name="mobileNumber"
                                                    value={userDetail.mobileNumber}
                                                    onChange={handleChange}
                                                    onBlur={() => setIsActive(false)}
                                                    onFocus={() => setIsActive(true)}
                                                    required
                                                />*/}

                                                <span className="countryCodeStyle">
                                                    {focusedField === 'mobileNumber' || userDetail.mobileNumber ? '+91' : ''}
                                                </span>
                                                {focusedField === 'mobileNumber' ? (
                                                    <MaskedInput
                                                        className="inputText inputForMobile"
                                                        type="tel"
                                                        mask={[/[6-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                                                        guide={false}
                                                        showMask={false}
                                                        placeholder=""
                                                        name="mobileNumber"
                                                        value={userDetail.mobileNumber}
                                                        onChange={handleChange}
                                                        onBlur={() => setFocusedField(null)}
                                                        autoFocus
                                                        required
                                                    />
                                                ) : (
                                                    <input
                                                        className="inputText inputForMobile"
                                                        type="tel"
                                                        name="mobileNumber"
                                                        placeholder=""
                                                        value={maskMobile(userDetail.mobileNumber)}
                                                        onFocus={() => setFocusedField('mobileNumber')}
                                                        readOnly
                                                    />
                                                )}

                                                <label className="label">Mobile Number</label>
                                            </div>
                                            <button className="shareButton" onClick={() => postData("mob")} disabled={!userDetail.mobileNumber}>Share</button>
                                        </div>
                                        <span className="shareQuoteErrorText">{error["mobileNumber"]}</span>
                                    </div>
                                    <div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                                        <div className="inputGroup">
                                            <div className="share_inp">
                                                {/*<span className="countryCodeStyle">
                                                    {isActive || userDetail.whatsappNumber ? '+91' : ''}
                                                </span>
                                                <MaskedInput
                                                    className="inputText inputForMobile"
                                                    mask={[
                                                        /[6-9]/,
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                    ]}
                                                    guide={false}
                                                    showMask={false}
                                                    placeholder=""
                                                    name="whatsappNumber"
                                                    value={userDetail.whatsappNumber}
                                                    onChange={handleChange}
                                                    onBlur={() => setIsActive(false)}
                                                    onFocus={() => setIsActive(true)}
                                                    required
                                                />*/}

                                                <span className="countryCodeStyle">
                                                    {focusedField === 'whatsappNumber' || userDetail.whatsappNumber ? '+91' : ''}
                                                </span>
                                                {focusedField === 'whatsappNumber' ? (
                                                    <MaskedInput
                                                        className="inputText inputForMobile"
                                                        type="tel"
                                                        mask={[/[6-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                                                        guide={false}
                                                        showMask={false}
                                                        placeholder=""
                                                        name="whatsappNumber"
                                                        value={userDetail.whatsappNumber}
                                                        onChange={handleChange}
                                                        onBlur={() => setFocusedField(null)}
                                                        autoFocus
                                                        required
                                                    />
                                                ) : (
                                                    <input
                                                        className="inputText inputForMobile"
                                                        type="tel"
                                                        name="whatsappNumber"
                                                        placeholder=""
                                                        value={maskMobile(userDetail.whatsappNumber)}
                                                        onFocus={() => setFocusedField('whatsappNumber')}
                                                        readOnly
                                                    />
                                                )}
                                                <label className="label">WhatsApp</label>

                                                <label className="label">WhatsApp</label>
                                            </div>
                                            <button className="shareButton" onClick={() => redirectToWhatsapp("wt")} disabled={!userDetail.whatsappNumber}>Share</button>
                                        </div>
                                        <span className="shareQuoteErrorText">{error["whatsappNumber"]}</span>
                                    </div>
                                </div>
                            </div>
                            <hr className="m-0" />
                            <div className="model_padding model_padding2">
                                <div className="share_link">
                                    <div className="label_copy">Copy and share link</div>
                                    <div className="share_inp2">
                                        <div className="ENQ_box">
                                            <CopyToClipboard text={copyURL} onCopy={handleCopy}>
                                                <p className="LeadID" ><span id="textCopeid" >&nbsp;{copyURL} <i className="far fa-copy"></i></span></p>
                                            </CopyToClipboard>
                                            {copyText && <div className="Enq_popup">Copied!</div>}
                                        </div>
                                        {/*<input
                                    type="text"
                                    value={copyURL}
                                    readOnly
                                />
                                <button className="shareButton" disabled={!copyURL} onClick={handleCopy}>{copySuccess}</button>*/}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            )}
        </div>
    );
};

export default ShareQuotations;
